module.exports = __webpack_public_path__ + "static/img/app.4fdfc2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/app.jpg
// module id = YXQ6
// module chunks = 4